<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M17 0.384005C17 0.533929 16.9236 0.646384 16.8091 0.721322C10.9299 3.94479 10.9299 8.51734 11.0443 9.71672L13.5257 9.71672C13.6784 9.71672 13.793 9.79168 13.8693 9.94161C13.9457 10.0541 13.9075 10.2415 13.8311 10.3539L7.76089 17.8501C7.68454 17.9625 7.57 18 7.45547 18C7.34094 18 7.22641 17.9625 7.15005 17.8501L1.0798 10.3165C1.00344 10.204 0.965265 10.0541 1.04162 9.90419C1.11797 9.79174 1.23251 9.6793 1.3852 9.6793L3.82855 9.6793C3.90491 6.90584 4.85935 4.69441 6.61544 3.04525C10.3567 -0.327905 16.3888 0.00936575 16.618 0.00936576C16.7707 0.00936577 16.9234 0.121808 16.9616 0.309212C16.9998 0.346692 16.9998 0.384173 16.9998 0.384173L17 0.384005Z"
    />
  </svg>
</template>
